<template>
  <transition name="slide">   
      <b-card no-body>
        <b-card-header>
              Dealer List
              <div class="pull-right">
                  <b-button size="sm" variant="primary" v-b-tooltip.hover title="Add New" @click.stop="add()"><i class="fa fa-plus"></i> Add New</b-button>
              </div>  
        </b-card-header>
        <b-card-body>
        <b-row>
          <b-col md="1">
              <b-form-select :options="pageOptions" v-model="perPage" />
          </b-col>
          <b-col md="4" offset-md="7">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"><i class="fa fa-times-circle"></i></b-btn>
                  </b-input-group-append>
                </b-input-group>
          </b-col>  
        </b-row>
        <br/>   
        <b-table responsive show-empty id="dealertable" :busy.sync="isBusy" :filter="filter" :items="myProvider" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(roleindex)="data">
            <strong>{{data.item.dealer_id }}</strong>
          </template>
          <template v-slot:cell(createddate)="data">
            {{data.item.createddate | dateTimeFormat }}
          </template>
          <template v-slot:cell(status)="data">
            <b-badge v-b-tooltip.hover :title="statusFormatter(data.item.status)"  :variant="getBadge(data.item.status)" v-html='statusFormatter(data.item.status)'></b-badge>
          </template>

          <template v-slot:cell(action)="data">
            <b-button-group>
                <b-button v-b-tooltip.hover title="Edit" size="sm" variant="primary" @click.stop="info(data.item)"><span> <i class="fa fa-edit"></i> Edit</span></b-button>
                <b-button v-b-tooltip.hover title="Delete" size="sm" variant="danger" @click.stop="del(data.item)"><span> <i class="fa fa-remove" ></i> Delete</span></b-button>
            </b-button-group>    
          </template>
        </b-table>
        <nav v-if="totalRows>0">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
      </b-card>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex' 
import { getResponseMessages } from '../../_helpers';
export default {
  name: 'Dealer_List',
  data: () => {
    return {
      itemsData: [],
      fields: [
        {key: 'dealer_id',sortable:true,label: 'Dealer Index'},
        {key: 'name',sortable:true,label: 'Dealer Name'},
        {key: 'usrname',sortable:true,label: 'Owner Name'},
        {key: 'status',sortable:true,label: 'Dealer Status'},
        {key: 'createddate',sortable:true, label: 'Created Date'},
        {key: 'action',label: 'Action'}
      ],
      isBusy: false,
      lastPerPage: 5,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [ 5, 25, 50, 100 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    ...mapGetters(["getRecordTotal", "getRecords"])
  },      
  methods: {
    ...mapActions('org', ['getList','delById']),
    myProvider(ctx){
      this.isBusy = true
      if(this.lastPerPage != ctx.perPage){
        this.lastPerPage = ctx.perPage;
        ctx.currentPage = 1;
      }
      var startVal = (ctx.currentPage-1) * ctx.perPage
      ctx['start'] = startVal
      ctx['length'] = ctx.perPage
      this.itemsData = [];
      let promise = this.$store.dispatch('getList',{ url:'dealer/index',data: ctx })
      let itemsx = []
      return promise.then((res) => {
          itemsx = this.$store.state.org.records
          this.totalRows = this.$store.state.org.recordTotal
          return(itemsx)
      })
      return(itemsx)
    },
    info (item) {
        this.$router.push('/dealer/edit/'+item.dealer_id)
    },
    add () {
        this.$router.push('/dealer/add')
    },
    statusFormatter(value){
        return value == 0 ? 'Active': 'Inactive';
    },
    del(item) {
        this.$swal({
            title: 'Are you sure?',
            text: 'You want to remove this dealer!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {
                this.$store.dispatch('delById', {url:'dealer/removeDealer',data : { 'dealerId':item.dealer_id }}).then((res) => {
                  
                  this.$swal('Deleted!',getResponseMessages(res.data.messages),'success')
                  this.$root.$emit('bv::refresh::table', 'dealertable');
                },(error) =>{
                  this.$swal('Cancelled',getResponseMessages(error.data.messages),'error')
                });
            }
          })
    },
    getBadge(value){
        return value == 0 ? 'success': 'danger';
    }  
  }
}
</script>
